import axios from 'axios'
import {
  InspectModel,
  LaundryInspectionModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getInspect(dto: InspectModel, page: number) {
  return axios.post<ResponseObjectPaginated<InspectModel[]>>(
    `${BASEURL}/maintenanceinspection/getAll/${page}`,
    dto,
  )
}
export function getInspectById(dto: string | undefined) {
  return axios.get<ResponseObject<InspectModel>>(
    `${BASEURL}/maintenanceinspection/getInformationById?id=${dto}`,
  )
}

export function createInspect(dto: InspectModel) {
  return axios.post<ResponseCRUD>(
    `${BASEURL}/maintenanceinspection/createMaintenanceInspection`,
    dto,
  )
}

export function deleteInspect(dto: any) {
  return axios.delete<ResponseCRUD>(
    `${BASEURL}/maintenanceinspection/deleteMaintenanceInspection?id=${dto}`,
  )
}

export function updateInspect(dto: InspectModel) {
  return axios.put<ResponseCRUD>(
    `${BASEURL}/maintenanceinspection/updateMaintenanceInspection`,
    dto,
  )
}

// DOCUMENT

export function getInspectDocument(page: number, id: string) {
  return axios.post<ResponseObjectPaginated<InspectModel[]>>(
    `${BASEURL}/maintenanceinspection/getAllDocuments/${page}?mantenimientoInspeccionId=${id}`,
  )
}

export function createInspectDocument(dto: InspectModel, id: string) {
  return axios.post<ResponseCRUD>(
    `${BASEURL}/maintenanceinspection/addDocument?mantenimientoInspeccionId=${id}`,
    dto,
  )
}

export function deleteInspectDocument(dto: any) {
  return axios.post<ResponseCRUD>(
    `${BASEURL}/maintenanceinspection/deleteDocument?documentoMantenimientoInspeccionId=${dto}`,
  )
}

export function updateInspectDocument(dto: InspectModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/maintenanceinspection/updateDocument`, dto)
}

export function getInspectionReportPDF(dto: LaundryInspectionModel) {
  return axios.post<any>(
    `${BASEURL}/maintenanceinspection/getDataDashboardMaintenanceInspectionReportPDF`,
    dto,
    {
      responseType: 'arraybuffer',
    },
  )
}

export function getInspectionReportXLSX(dto: LaundryInspectionModel) {
  return axios.post<any>(
    `${BASEURL}/maintenanceinspection/getDataDashboardMaintenanceInspectionReportExcel`,
    dto,
    {
      responseType: 'arraybuffer',
    },
  )
}

export function getInspectionReportCSV(dto: LaundryInspectionModel) {
  return axios.post<any>(
    `${BASEURL}/maintenanceinspection/getDataDashboardMaintenanceInspectionReportCSV`,
    dto,
    {
      responseType: 'arraybuffer',
    },
  )
}
